export enum HalloweenFilter {
  id = '999',
  type = 'halloween',
}